import { create } from "zustand";

const usePreferencesStore = create((set) => ({
  preferences: {
    prefix: "bla", // Valore di default
    hideNotes: false,
    email_is_mandatory: false,
    mostra_prezzo_finale: false,
    mostra_prezzi_listino: false,
  },
  setupPreferences: (newPreferences) =>
    set((state) => ({
      preferences: {
        ...state.preferences,
        ...newPreferences,
        prefix: newPreferences.prefix || "da", // Usa il prefix dalle preferences se presente, altrimenti usa "bla"
        hideNotes: newPreferences.form_type === "tim",
        email_is_mandatory: newPreferences.email_is_mandatory,
        mostra_prezzo_finale: newPreferences.mostra_prezzo_finale !== "0",
        mostra_prezzi_listino: newPreferences.mostra_prezzi_listino !== "0",
      },
    })),
}));

export default usePreferencesStore;
